import { Platform, StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

export const getSquadLeaderboardSearchStyles = (theme: Theme, isDark: boolean) =>
  StyleSheet.create({
    outer: {
      marginHorizontal: 16,
      marginBottom: 8,
    },
    pill: {
      flexDirection: 'row',
      alignItems: 'center',
      height: 38,
      borderRadius: 19,
      borderWidth: 1,
      borderColor: isDark ? theme.primary + '33' : theme.gray[300],
      backgroundColor: theme.background.card,
      paddingHorizontal: 10,
      ...(Platform.OS === 'web' && {
        boxShadow: isDark
          ? (`0 1px 4px rgba(0,0,0,0.3)` as never)
          : (`0 1px 4px rgba(0,0,0,0.06)` as never),
      }),
      ...(Platform.OS !== 'web' && {
        shadowColor: theme.shadow,
        shadowOffset: { width: 0, height: 1 },
        shadowOpacity: isDark ? 0.25 : 0.08,
        shadowRadius: 3,
        elevation: 1,
      }),
    },
    iconLeading: {
      width: 22,
      alignItems: 'center',
      justifyContent: 'center',
    },
    input: {
      flex: 1,
      minHeight: 32,
      paddingVertical: 0,
      paddingHorizontal: 6,
      margin: 0,
      fontSize: 14,
      fontWeight: '500',
      color: theme.gray[900],
      backgroundColor: 'transparent',
      ...(Platform.OS === 'web' && {
        outlineStyle: 'none' as never,
        outlineWidth: 0,
      }),
    },
    clearButton: {
      width: 26,
      height: 26,
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 13,
    },
    clearButtonHover: {
      ...(Platform.OS === 'web' && {
        backgroundColor: theme.primary + '14',
      }),
    },
    pressed: {
      opacity: 0.7,
    },
  });
